import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  FormControl, ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {User} from "../../services/user/user";
import {RatesSroMasterService} from "../../services/rates-sro-master/rates-sro-master.service";
import {AlertService} from "../../services/alert/alert.service";
import {LoadingService} from "../../services/loading/loading.service";
import {StateCountryService} from "../../services/state-country/state-country.service";
import {UserService} from "../../services/user/user.service";
import { CommonModule } from '@angular/common';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {CommonValidators} from "../../shared/common-components/common-validators";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import AppConstants from "../../shared/common-components/AppConstants";
import {FrtShipmentPackagesEntity, NameAndAddress, StateCountry} from "../../shared/common-components/common-structure";
import {filter, map, shareReplay, tap} from "rxjs/operators";
import { BehaviorSubject, Observable, takeWhile} from "rxjs";
import {TypeaheadMatch, TypeaheadModule, TypeaheadOptions} from "ngx-bootstrap/typeahead";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {FrtOtoRateQueryAddressesComponent} from "./frt-oto-rate-query-addresses/frt-oto-rate-query-addresses.component";
import {Router} from "@angular/router";
import {
  FrtOtoShipmentPackageInfoModalComponent
} from "./frt-oto-shipment-package-info/frt-oto-shipment-package-info.component";
import {FrtOtoRequest} from "../../services/frt-oto-rate-query/frt-oto-request";
import {FrtOtoRateQueryService} from "../../services/frt-oto-rate-query/frt-oto-rate-query.service";

@Component({
  selector: 'app-frt-oto-rate-query',
  imports: [
    ReactiveFormsModule,
    BsDatepickerModule,
    TimepickerModule,
    CommonModule,
    TypeaheadModule
  ],
  templateUrl: './frt-oto-rate-query.component.html',
  styleUrl: './frt-oto-rate-query.component.css'
})
export class FrtOtoRateQueryComponent implements OnInit, OnDestroy {
  orgId: any;
  showGssrError: Boolean = false;
  private defaultCountry = new BehaviorSubject<StateCountry>(null);
  typeaheadOriginLoading: boolean;
  typeaheadDestinationLoading: boolean;
  dataSourceOrigin: Observable<any>;
  dataSourceDestination: Observable<any>;
  bsModalRef: BsModalRef;
  typeaheadLoading: any;

  allCountriesFrtList$ = this.stateCountryService.getAllCountries().pipe(
    map(stateCountries => stateCountries.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1 && (country.parentCountryId === 365 || country.parentCountryId === 326)) ),
    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.defaultCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );
  freightQueryForm: UntypedFormGroup;
  listHrs: {key: String, value:String}[] = [];
  tmssloader: any;
  minDate = new Date();
  maxDate = new Date();
  currentUser: User;
  allAddressExist = false;
  nameAndAddresses: NameAndAddress[] = [];
  addressFormValues: any;
  addressDisplayItems: Array<{ label: string; lines: string[] }> = [];
  shipmentPackages: FrtShipmentPackagesEntity[] = [];
  packageDisplayItems: Array<{label: string; lines: string[]}> = [];
  packageFormDraft: any;
  packagesExist = false;
  validationMessages = {
    'moveDate': [
      {type: 'required', message: 'Pickup Date is required'}
    ],
    'requiredDeliveryDate': [
      {type: 'required', message: 'Delivery Date is required'}
    ]
  };
  observer$ = new BehaviorSubject(true);
  constructor(private ratesSroMasterService: RatesSroMasterService, private router: Router, private frtOtoRateQueryService: FrtOtoRateQueryService,
              private formBuilder: UntypedFormBuilder, private alertService: AlertService, private modalService: BsModalService,
              private loader: LoadingService, private stateCountryService: StateCountryService,
              private userService: UserService) {
    this.minDate.setFullYear(this.minDate.getFullYear() - 6);
    this.tmssloader = this.loader;
    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.freightQueryForm.get('asyncOriginSearchString').value)
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.dataSourceDestination = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.freightQueryForm.get('asyncDestinationSearchString').value)
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
  }

  /**
   * @description initializes the form and gets all the accessorials
   */
  ngOnInit() {
    this.initializeForm();
    this.generateHours();
    this.getCurrentUser();
    this.onValueChanges();
    this.defaultCountry
      .pipe(filter(value => value != null))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(defaultCountry => {
        this.freightQueryForm.get('originCountryId').setValue(defaultCountry, {emitEvent: false, onlySelf: false});
        this.freightQueryForm.get('destinationCountryId').setValue(defaultCountry, {emitEvent: false, onlySelf: false});
      });
  }

  generateHours(){
    this.listHrs = AppConstants.generateHours();
  }

  submit() {
    /*if (this.freightQueryForm.invalid || !this.allAddressExist || !this.packagesExist || !this.currentUser) {
      this.freightQueryForm.markAllAsTouched();
      this.alertService.info('Complete the request, address, and package information before submitting.');
      return;
    }*/
    // TODO fix the submit enable/disable condition
    if (this.freightQueryForm.invalid || !this.currentUser) {
      this.freightQueryForm.markAllAsTouched();
      this.alertService.info('Complete the request, address, and package information before submitting.');
      return;
    }
    const formValue = this.freightQueryForm.getRawValue();
    const payload = new FrtOtoRequest();
    payload.requestDateTime = new Date().toISOString();
    payload.userId = this.currentUser.id;
    payload.organizationId = this.currentUser.organizationId;
    payload.queryType = 'FRT';
    payload.quoteDateby = new Date(formValue.requestDateTime).toISOString();
    payload.fundingPaAuthority = 0;
    payload.expediteFreightShipment = formValue.expediteFreightShipment === 'yes' ? 1 : 0;
    payload.pickupDate = new Date(formValue.moveDate).toISOString();
    payload.pickupTime = formValue.moveDateTime;
    payload.requiredDeliveryDate = new Date(formValue.requiredDeliveryDate).toISOString();
    payload.deliveryTime = formValue.requiredDeliveryDateTime;
    payload.declaredShipmentValue = formValue.declaredValue;
    payload.pocAtPickup = "";
    payload.pocAtPickupPhone = "";
    payload.pocAtPickupEmail = "";
    payload.pickupLocationname = "";
    payload.pickupRestrictions = formValue.moveDateComments;
    payload.pocAtDestination = "";
    payload.pocAtDestinationPhone = "";
    payload.pocAtDestinationEmail = "";
    payload.destinationLocationName = "";
    payload.destinationRestrictions = formValue.deliveryDateComments;
    payload.estimatedWeight = formValue.estimatedWeight;
    payload.estimatedMiles = formValue.estimatedMiles;
    payload.estimatedCuFt = formValue.estimatedCuFt;
    payload.additionalNotes = formValue.additionalNotes;
    // payload.nameAndAddressEntity = this.nameAndAddresses;
    // payload.frtShipmentPackagesEntity = this.shipmentPackages;
    payload.originZipId = formValue.originId.uspsZipId;
    payload.destinationZipId =  formValue.destinationId.uspsZipId;
    payload.originCountryId =  formValue.originCountryId.stateCountryId;
    payload.destinationCountryId =  formValue.destinationCountryId.stateCountryId;
    console.log(payload);
    this.loader.show();
    this.frtOtoRateQueryService.saveOtoRequest(payload).subscribe(() => {
      this.loader.hide();
      this.alertService.success('FRT OTO request submitted successfully.');
      this.router.navigate(['/frtotobidsreview']);
    }, () => {
      this.loader.hide();
      this.alertService.error('Error occurred while submitting the FRT OTO request. Please contact system administrator.');
    });
  }

  /**
   * @description initializes frt query form.
   */
  initializeForm() {
    this.freightQueryForm = this.formBuilder.group({
      requestDateTime: new FormControl(new Date(), Validators.required),
      expediteFreightShipment: new FormControl(null, Validators.required),
      shipper: new FormControl('', Validators.required),
      customer: new FormControl('', Validators.required),
      shipperEmail: new FormControl('', [Validators.required, CommonValidators.email]),
      shipperPhone: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(15), CommonValidators.numeric]),
      agencyShipmentIdNo: new FormControl(null),
      agencyLocationCode: new FormControl(null),
      declaredValue: new FormControl(null, Validators.required),
      tspProBillNo: new FormControl(null),
      moveDateComments: new FormControl(''),
      deliveryDateComments: new FormControl(''),
      additionalNotes: new FormControl(''),
      moveDate: new FormControl('', Validators.required),
      moveDateTime: new FormControl('', Validators.required),
      requiredDeliveryDate: new FormControl('', Validators.required),
      requiredDeliveryDateTime: new FormControl('', Validators.required),
      originId: new FormControl(null, [Validators.required]),
      destinationId: new FormControl(null, [Validators.required]),
      originCountryId: new FormControl(null, [Validators.required]),
      destinationCountryId: new FormControl(null, [Validators.required]),
      asyncOriginSearchString: new FormControl(null),
      asyncDestinationSearchString: new FormControl(null),
      estimatedWeight: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{1,8}?$')]),
      estimatedMiles: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+(.[0-9]{1,2})?$')]),
      estimatedCuFt: new FormControl(null, [Validators.pattern('^[0-9]*$')]),
    });
  }

  pickUpDateChange(pickupdate: any) {
    this.freightQueryForm.get('moveDate').setValue(pickupdate.target.value);
  }
  deliveryDateChange(pickupdate: any) {
    this.freightQueryForm.get('requiredDeliveryDate').setValue(pickupdate.target.value);
  }

  isAddressInvalid() {
    // return this.freightQueryForm.invalid;
    return false;
  }

  enterAddressModal() {
    const initialState = {addressForms: this.addressFormValues};
    this.bsModalRef = this.modalService.show(FrtOtoRateQueryAddressesComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
    this.bsModalRef.content.emitData.subscribe(result => {
      this.addressFormValues = result;
      const addressValues: Array<[string, any, boolean]> = [
        ['Origin', result?.origin, true],
        ['Shipper', result?.shipper, false],
        ['Bill To', result?.billTo, false],
        ['Destination', result?.destination, true],
        ['Consignee', result?.consignee, false],
        ['Issue Office', result?.issuingOffice, false]
      ];
      this.nameAndAddresses = addressValues
        .filter(([, address, required]) => required || this.hasAddressData(address))
        .map(([recordType, address]) => this.toOtoAddress(recordType, address));
      this.allAddressExist = result?.isRequiredComplete === true;
      const office = result?.issuingOffice;
      this.addressDisplayItems = [
        {label: 'Origin', address: result?.origin, required: true},
        {label: 'Destination', address: result?.destination, required: true},
        {label: 'Shipper', address: result?.shipper, required: false},
        {label: 'Bill To', address: result?.billTo, required: false},
        {label: 'Consignee', address: result?.consignee, required: false}
      ]
        .filter(item => item.required || this.hasAddressData(item.address))
        .map(item => ({label: item.label, lines: this.formatAddressLines(item.address)}));
      const officeLines = [
        [office?.firstName, office?.middleInitial, office?.lastName].filter(Boolean).join(' '),
        office?.issuingOfficerTitle,
        office?.issuingOfficeName,
        office?.phone ? `Phone: ${office.phone}` : null
      ].filter(Boolean);
      if (officeLines.length) this.addressDisplayItems.push({label: 'Issuing Office', lines: officeLines});
    });
  }

  private toOtoAddress(recordType: string, formValue: any): NameAndAddress {
    const address: any = Object.assign(new NameAndAddress(recordType), {
      nameAddressId: null,
      frtOtoRequestId: null,
      shipmentsId: null,
      defaultAddress: null,
      firstName: formValue?.firstName || null,
      lastName: formValue?.lastName || null,
      middleInitial: formValue?.middleInitial || null,
      addressLine1: formValue?.addressLine1 || null,
      addressLine2: formValue?.addressLine2 || null,
      city: formValue?.city || null,
      state: formValue?.state || null,
      stateId: formValue?.stateId || null,
      zipCode: formValue?.zipCode || null,
      countryId: formValue?.countryId || null,
      phone: formValue?.phone || null,
      phoneExt: formValue?.phoneExt || null,
      emailAddress: formValue?.emailAddress || null,
      alternatePhone: formValue?.alternatePhone || null,
      otherContactInfo: formValue?.otherContactInfo || null,
      issuingOfficerTitle: formValue?.issuingOfficerTitle || null,
      issuingOfficeName: formValue?.issuingOfficeName || null
    });
    return address as NameAndAddress;
  }

  private hasAddressData(address: any): boolean {
    if (!address) return false;
    return [
      address.firstName, address.lastName, address.middleInitial,
      address.addressLine1, address.addressLine2, address.city, address.state,
      address.zipCode, address.phone, address.phoneExt, address.emailAddress,
      address.alternatePhone, address.otherContactInfo,
      address.issuingOfficerTitle, address.issuingOfficeName
    ].some(value => value !== null && value !== undefined && String(value).trim() !== '');
  }

  private formatAddressLines(address: any): string[] {
    if (!address) return ['No address entered'];
    const street = [address.addressLine1, address.addressLine2].filter(value => !!value && String(value).trim());
    const locality = [address.city, address.state, address.zipCode]
      .filter(value => !!value && String(value).trim()).join(', ');
    const contact = [
      address.phone ? `Phone: ${address.phone}${address.phoneExt ? ` ext. ${address.phoneExt}` : ''}` : null,
      address.emailAddress ? `Email: ${address.emailAddress}` : null
    ].filter(Boolean);
    const lines = [...street, ...(locality ? [locality] : []), ...contact];
    return lines.length ? lines : ['No address entered'];
  }

  private packageWeightMatchesEstimate(): boolean {
    if (!this.shipmentPackages?.length) return false;
    const estimatedWeight = Number(this.freightQueryForm?.get('estimatedWeight')?.value);
    if (!Number.isFinite(estimatedWeight)) return false;
    const packageWeight = this.shipmentPackages.reduce((total, item) => total + Number(item.packageWeight || 0), 0);
    return Math.abs(packageWeight - estimatedWeight) <= 0.001;
  }

  openPackageModal() {
    const initialState = {
      isOtoRequestMode: true,
      estimatedWeight: Number(this.freightQueryForm.get('estimatedWeight').value),
      estimatedCubic: Number(this.freightQueryForm.get('estimatedCuFt').value),
      organizationId: this.currentUser?.organizationId,
      packages: this.shipmentPackages,
      packageDraft: this.packageFormDraft
    };
    this.bsModalRef = this.modalService.show(FrtOtoShipmentPackageInfoModalComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
    this.bsModalRef.content.emitData.subscribe(result => {
      this.shipmentPackages = result?.packages || [];
      this.packageFormDraft = result?.draft;
      this.packagesExist = result?.isComplete === true && this.packageWeightMatchesEstimate();
      this.packageDisplayItems = this.shipmentPackages.map((item, index) => ({
        label: `Package ${index + 1}`,
        lines: [
          item.frtPackageTypesEntity?.packageDescription || `Package type ${item.packageTypeId}`,
          item.commodityDesc ? `Commodity: ${item.commodityDesc}` : null,
          `Pieces: ${item.totalPieces}${item.noOfLoosePieces ? ` (${item.noOfLoosePieces} loose)` : ''}`,
          item.noOfPallets ? `Pallets: ${item.noOfPallets}` : null,
          `Weight: ${item.packageWeight} lbs`,
          item.cubicFeet !== null && item.cubicFeet !== undefined ? `Cube: ${item.cubicFeet} cu ft` : null,
          item.truckNum ? `Truck: ${item.truckNum}` : null,
          item.hazmatIndicator ? 'Hazmat: Yes' : null,
          item.appropriationChargeCode ? `Charge code(s): ${item.appropriationChargeCode}` : null,
          item.otherAppropriationChargeCode ? `Other charge code: ${item.otherAppropriationChargeCode}` : null,
          item.additionalComments ? `Additional information: ${item.additionalComments}` : null
        ].filter((line): line is string => Boolean(line))
      }));
      const draft = result?.draft?.formValue;
      const draftLines = [
        draft?.packageType ? `Package type: ${draft.packageType}` : null,
        draft?.freightCommodityDesc ? `Commodity: ${draft.freightCommodityDesc}` : null,
        draft?.totalPieces ? `Pieces: ${draft.totalPieces}` : null,
        draft?.weight ? `Weight: ${draft.weight} lbs` : null,
        draft?.cube ? `Cube: ${draft.cube} cu ft` : null,
        draft?.addtinfo ? `Additional information: ${draft.addtinfo}` : null
      ].filter((line): line is string => Boolean(line));
      if (draftLines.length) this.packageDisplayItems.push({label: 'Package in progress', lines: draftLines});
    });
  }

  pcMilerService(originZipCode, destinationZipCode, pickUpDate) {
    if (originZipCode !== null && destinationZipCode !== null && originZipCode !== undefined && destinationZipCode !== undefined
      && originZipCode !== '' && destinationZipCode !== '') {
      this.loader.show();
      this.ratesSroMasterService.getMiles(originZipCode, destinationZipCode, 'FRT', pickUpDate.toISOString()).subscribe(estimatedMiles => {
        // this.freightQueryForm.get('estimatedMiles').patchValue(new RoundPipe().transform(estimatedMiles), {
        this.freightQueryForm.get('estimatedMiles').patchValue(estimatedMiles);
        this.loader.hide();
      }, error2 => {
        this.loader.hide();
        this.alertService.info('cannot get the mileage between the above origin and destination');
      });
    }

  }

  onValueChanges() {
    this.freightQueryForm.get('estimatedWeight').valueChanges.subscribe(() => {
      this.packagesExist = this.packageWeightMatchesEstimate();
    });
    this.freightQueryForm.get('originId').valueChanges.subscribe(origin => {
      if (origin) {
        this.allAddressExist = false;
        this.nameAndAddresses = [];
        this.addressFormValues = null;
      }
      // this.freightQueryForm.get('estimatedWeight').setValue(null);
      if (origin) {
        if (this.freightQueryForm.get('destinationId').value) {
          const originZipCode = origin.zipCode;
          const destinationZipCode = this.freightQueryForm.get('destinationId').value.zipCode;
          const pickupDate = this.freightQueryForm.get('requestDateTime').value;
          //const pickupdateFormatted = moment(pickupDate).format('MM/dd/yyyy');
          if (AppConstants.isNotNullCondition(this.currentUser)) {
            this.pcMilerService(originZipCode, destinationZipCode, pickupDate);
          }
        }
      }
    });
    this.freightQueryForm.get('destinationId').valueChanges.subscribe(destination => {
      if (destination) {
        this.allAddressExist = false;
        this.nameAndAddresses = [];
        this.addressFormValues = null;
      }
      this.freightQueryForm.get('estimatedMiles').setValue(null);
      if (destination) {
        if (this.freightQueryForm.get('originId').value) {
          const originZipCode = this.freightQueryForm.get('originId').value.zipCode;
          const destinationZipCode = destination.zipCode;
          const pickupDate = this.freightQueryForm.get('requestDateTime').value;
          //const pickupdateFormatted = moment(pickupDate).format('MM/dd/yyyy');
          // calling pc miler for non carrier users only
          if (AppConstants.isNotNullCondition(this.currentUser)) {
            this.pcMilerService(originZipCode, destinationZipCode, pickupDate);
          }
        }
      }
    });
  }

  getCurrentUser() {
    this.userService
      .getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe((currentUser) => {
        this.currentUser = currentUser;
        if (AppConstants.isNotNullCondition(this.currentUser)) {
          this.freightQueryForm.get('shipper').setValue(this.currentUser.agencyBureauName);
          this.freightQueryForm.get('shipper').disable();
          this.freightQueryForm.get('customer').setValue(this.currentUser.firstName + this.currentUser.lastName);
          this.freightQueryForm.get('customer').disable();
          this.freightQueryForm.get('shipperEmail').setValue(this.currentUser.email);
          this.freightQueryForm.get('shipperEmail').disable();
          this.freightQueryForm.get('shipperPhone').setValue(this.currentUser.phone);
          this.freightQueryForm.get('shipperPhone').disable();
          this.orgId = this.currentUser.organizationId;
        } else {
          this.orgId = -1;
        }
      });
  }

  generateDefaultTime(){
    const x = new Date();
    x.setHours(0,0,0,0);
    return x;
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * @description formats the date into yyyy-mm-dd format
   * @param date: Jan 01, 0000
   */
  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  compareCountryFn(c1: StateCountry, c2: StateCountry) {
    return c1 && c2 ? c1.stateCountryId === c2.stateCountryId : c1 === c2;
  }

  isFormElementInValid(fullFormControlName: string) {
    const fromElement = this.freightQueryForm.get(fullFormControlName);
    return fromElement && fromElement.invalid &&
      fromElement.touched;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.freightQueryForm.get('originId').setValue(e.item);
  }

  typeaheadDestinationOnSelect(e: TypeaheadMatch): void {
    this.freightQueryForm.get('destinationId').setValue(e.item);
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  changeTypeaheadDestinationLoading(e: boolean): void {
    this.typeaheadDestinationLoading = e;
  }

  onWeightCubicFtChange() {
    this.showGssrError = false;
    if (this.freightQueryForm.get('estimatedWeight').value && this.freightQueryForm.get('estimatedCuFt').value) {
      const minCubicFt = (this.freightQueryForm.get('estimatedWeight').value / 40);
      this.showGssrError = !(this.freightQueryForm.get('estimatedCuFt').value >=  minCubicFt);
    }
  }
}
